import React, { Component } from 'react';
import Loading from './../components/Loading';
import PreloadImage from 'react-preload-image';

const API = 'https://willcer.com/admin/wp-json/wp/v2/';
const QUERY = 'posts?_embed&filter[orderby]=menu_order&order=desc';

class Blog extends Component {
    constructor(props) {
        super(props);
        this.state = { dataSet: [], isLoading: false }
    }
    
    componentDidMount() {
        this.setState({ isLoading: true });
        fetch(API+QUERY)
            .then(response => {
                if  (response.ok) {
                    return response.json();
                } else {
                    throw new Error('Data unavailbale.');
                }
            })
        .then(response => { this.setState({ dataSet: response, isLoading: false }) })
        .catch(error => this.setState({ error, isLoading: false }));
    }

    truncateContent(content, numWords) {
        return content.split(" ").splice(0,numWords).join(" ")+"...";
    }

    render() {
        const { dataSet, isLoading, error } = this.state;
        if (error) {
          return <p>{error.message}</p>;
        }
        if (isLoading) {
            return <Loading />;
        }
        let mainUrl = "blog/";
        let posts = dataSet.map((post, index) => {
            function fPostHasImage(post, mode) {
                if (post.featured_media > 0){
                    let sourceUrl = post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.source_url;
                    let imageAlt = post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.alt;
                    if (mode === "sourceUrl")
                        return  sourceUrl;
                    else if (mode === "alt")
                        return  imageAlt;  
                }
            }
            let imageUrl = fPostHasImage(post, "sourceUrl");
            return (
                <div className="post" key={index}>
                    <div className="text">
                        <a className="title" href={mainUrl+post.slug}>
                            <h1>{post.title.rendered}</h1>
                        </a>
                        <div className="excerpt" dangerouslySetInnerHTML={{__html: post.excerpt.rendered }}></div>
                        <p className="content" dangerouslySetInnerHTML={{__html: this.truncateContent(post.content.rendered, 80)}}></p>
                        <p className="end"></p><a className="readMore" href={mainUrl+post.slug}>Read</a>
                    </div>
                    <div className="image">
                        <div className="box" id="box1">
                            <a href={mainUrl+post.slug}>
                                <PreloadImage
                                    className="loading"
                                    src={imageUrl} 
                                    lazy
                                    duration="1000ms"
                                />
                            </a>
                        </div>
                    </div>
                </div>
            )
        });
        return (
                <div className="blog">
                    <div className="posts">
                        <div className={ this.props.display }>
                            { posts }
                        </div>
                    </div>
                </div>
        );
    }
}

export default Blog;